import React from 'react';

const VatSummary = ({ data }) => {
    if (!data) return null;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">VAT Summary</h6>
                <div className="row text-center g-2 mb-3">
                    <div className="col-12">
                        <div className="p-3 bg-light rounded">
                            <small className="text-muted d-block">Total VAT Charged</small>
                            <h4 className="mb-0 fw-bold">{data.total_vat?.toLocaleString(undefined, { minimumFractionDigits: 3 })} BHD</h4>
                        </div>
                    </div>
                </div>
                {data.vat_rates && data.vat_rates.length > 0 && (
                    <>
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>VAT Rate Distribution</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>VAT Rate</th>
                                        <th className="text-end">Orders</th>
                                        <th className="text-end">Taxable Amount</th>
                                        <th className="text-end">VAT Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.vat_rates.map((r, i) => (
                                        <tr key={i}>
                                            <td>{r.vat_rate}%</td>
                                            <td className="text-end">{r.count}</td>
                                            <td className="text-end">{r.taxable_amount?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                            <td className="text-end">{r.vat_amount?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default VatSummary;
